import { Tab } from '@headlessui/react'
import { clsx } from 'clsx'
import { useLayoutVariant } from '../../hooks/useLayoutVariant'

export default function Tabs({ 
  children, 
  selectedIndex,
  onChange,
  className = '' 
}) {
  return (
    <Tab.Group selectedIndex={selectedIndex} onChange={onChange} className={className}>
      {children}
    </Tab.Group>
  )
}

export function TabList({ children, className = '' }) {
  const { isAdminAppUI } = useLayoutVariant()
  return (
    <Tab.List className={clsx(
      isAdminAppUI
        ? 'bg-[#1f2d40] border border-[#243246] rounded-[10px] p-1 inline-flex gap-1'
        : 'bg-white border border-pastel-pink rounded-2xl p-1.5 inline-flex gap-1.5',
      className
    )}>
      {children}
    </Tab.List>
  )
}

export function TabItem({ children, className = '' }) {
  const { isAdminAppUI } = useLayoutVariant()
  return (
    <Tab className={({ selected }) =>
      clsx(
        isAdminAppUI ? 'py-2 px-3 rounded-[7px] font-medium text-xs transition-all focus:outline-none' : 'py-2.5 px-4 rounded-xl font-medium text-sm transition-all focus:outline-none',
        selected
          ? (isAdminAppUI
            ? 'bg-[#1a2535] text-[#00c896]'
            : 'bg-gradient-to-r from-pastel-teal to-primary-400 text-white shadow-soft')
          : (isAdminAppUI
            ? 'text-[#7a8fa6] hover:text-[#e8edf5] hover:bg-[rgba(0,200,150,0.06)]'
            : 'text-slate-500 hover:text-pastel-ink hover:bg-pastel-cream'),
        className
      )
    }>
      {children}
    </Tab>
  )
}

export function TabPanels({ children, className = '' }) {
  return (
    <Tab.Panels className={className}>
      {children}
    </Tab.Panels>
  )
}

export function TabPanel({ children, className = '' }) {
  return (
    <Tab.Panel className={clsx('focus:outline-none', className)}>
      {children}
    </Tab.Panel>
  )
}

